<div class="dashboard-sidebar">
  <!-- <div class="sidebar-logo">
    <mat-icon class="logo-icon">business</mat-icon>
    <span class="logo-text">Mapix</span>
  </div> -->

  <div class="user-container">
    <div class="user-avatar">
      <mat-icon class="avatar-icon">person</mat-icon>
    </div>
    <div class="user-info">
      <h3 class="user-name">{{regularName || 'Usuario'}}</h3>
      <p class="user-mail">{{userEmail || userName}}</p>
      <p class="user-mail">{{authService.roleItem$ | async}}</p>
    </div>
  </div>

  <div class="months-container">
    <div class="month-title">MES</div>
    <div class="month-list">
      <div 
        *ngFor="let month of months" 
        class="month-item"
        [class.month-selected]="month.selected"
        (click)="onMonthClick(month.value)">
        {{month.name}}
      </div>
    </div>
  </div>
</div>
